// create forget password component with ui like VerifyEmailPage component

import { use, useActionState, useEffect } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Label from "../../components/label";
import Input from "../../components/input";
import { Button } from "../../components/button";
import {
  AtSymbolIcon,
  ExclamationCircleIcon,
  ArrowRightIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import FormError from "../../components/form-error";
import Fonts from "../../core/fonts";
import { forgetPassword, State } from "./actions/forgetPassword";

export default function ForgetPasswordPage() {
  const navigate = useNavigate();
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || "/";
  const initialState: State = {
    errors: {},
    error: {
      message: "",
      code: "",
    },
    success: false,
    defaultValues: {
      email: "",
    },
  };
  const [state, formAction, isPending] = useActionState(
    forgetPassword,
    initialState
  );

  useEffect(() => {
    if (state?.success) {
      navigate("/auth/reset-password?email=" + state.defaultValues?.email);
    }
  }, [state, callbackUrl]);

  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    auth.loaded(false);
  };

  return (
    <div className="flex items-center justify-center flex-1">
      <form
        className="space-y-3 w-full max-w-md"
        action={formAction}
        onSubmit={handleOnSubmit}
      >
        <div className="flex-1 rounded-lg bg-gray-50 px-6 pb-4 pt-8">
          <h1 className={`${Fonts.lusitanaRegular} mb-3 text-2xl`}>
            Forgot your password?
          </h1>
          <p>
            Enter your email address below and we will send you a code to reset your password.
          </p>
          <div className="w-full text-left">
            
            <div className="mt-4">
              <Label className="text-xs mb-3 text-gray-900" htmlFor="email">
                Email
              </Label>
              <Input
                id="email"
                type="email"
                name="email"
                placeholder="Enter your email address"
                required
                Icon={AtSymbolIcon}
                aria-describedby="email-error"
                defaultValue={state && state.defaultValues?.email}
              />
              <FormError
                id="email-error"
                message={state && state.errors?.email}
              ></FormError>
            </div>
          </div>
             <div>
            <Button className="mt-8 w-full" aria-disabled={isPending}>
              Send Reset Code
              <ArrowRightIcon className="ml-auto h-5 w-5 text-gray-50" />
            </Button>
          </div>
          <div className="flex h-8 items-end space-x-1">
            {state && !state.success && state.error && state.error.message && (
              <>
                <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
                <p className="text-sm text-red-500">{state.error.message}</p>
              </>
            )}
          </div>
       
          <div className="mt-1 flex w-full items-center justify-around text-purple-500">
            <Link to={"/auth/login"}>
              <span>Back to Login</span>
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
}